/**
 * POFSIS Shell PWA routing — edit valid origins here (not .env).
 * CURRENT_PWA = this origin (pofmain shell).
 * CHAT_PWA = any origin in chatOrigins (same-window so Chrome may hand off to Chat PWA).
 */
export const PWA_ROUTING_CONFIG = {
	currentPwaOrigin: typeof window !== "undefined" ? window.location.origin : "",

	/**
	 * Valid Chat PWA origins. Add/remove URLs as needed.
	 * Match against `new URL(...).origin` (no trailing path).
	 */
	chatOrigins: [
		// =========================================================
        // LOCAL
        // =========================================================
        "http://localhost:3000",

        // =========================================================
        // POFSIS MAIN
        // =========================================================
		"https://dev-sls-pofsis.pofsis.com",
		"https://sb-sls-pofsis.pofsis.com",
		"https://pofsis.pofsis.com",
        "https://pofsis.com",

        // =========================================================
        // POFCHAT
        // =========================================================
        "https://dev-chat.pofsis.com",
        "https://sb-chat.pofsis.com",
        "https://chat.pofsis.com",

        // =========================================================
        // JOBS / POFCAREERS
        // =========================================================
        "https://dev-job.pofsis.com",
        "https://sb-job.pofsis.com",
        "https://job.pofsis.com",

        // =========================================================
        // POFSHOP
        // =========================================================
        "https://dev-shop.pofsis.com",
        "https://sb-shop.pofsis.com",
        "https://shop.pofsis.com",

        // =========================================================
        // PAYMESHARE
        // =========================================================
        "https://dev-paymeshare.pofsis.com",
        "https://sb-paymeshare.pofsis.com",
        "https://paymeshare.pofsis.com",

        // =========================================================
        // REFERRALS
        // =========================================================
        "https://dev-referral.pofsis.com",
        "https://sb-referral.pofsis.com",
        "https://referral.pofsis.com",

        // =========================================================
        // POF PERSONAL
        // =========================================================
		"https://dev-personal.pofsis.com",
		"https://sb-personal.pofsis.com",
        "https://personal.pofsis.com",
        "https://personal-main.pofsis.com",

        // =========================================================
        // POF ACADEMY
        // =========================================================
		"https://dev-v2-academy.pofsis.com",
		"https://sb-v2-academy.pofsis.com",
        "https://academy.pofsis.com",

        // =========================================================
        // SUREIPASS / POF SIP
        // =========================================================
        "https://dev-v2-sureipass.pofsis.com",
        "https://sb-v2-sureipass.pofsis.com",
        "https://v2-sureipass.pofsis.com",

        // =========================================================
        // TEAM BOND
        // =========================================================
		"https://dev-teambond.pofsis.com",
		"https://sb-teambond.pofsis.com",
        "https://teambond.pofsis.com",

        // =========================================================
        // POFSIS BUSINESS
        // =========================================================
		"https://dev-business.pofsis.com",
		"https://sb-business.pofsis.com",
        "https://business.pofsis.com",
	],
};
